var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.configData
    ? _c(
        "div",
        [
          _c(
            "form-wrapper",
            {
              staticClass: "form-wrapper md-layout-item form",
              attrs: { validator: _vm.$v.configData },
            },
            [
              _c("div", { staticClass: "md-layout" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-size-20 md-medium-size-30 md-small-size-50 md-xsmall-size-100",
                  },
                  [
                    _c(
                      "md-radio",
                      {
                        attrs: { value: false },
                        model: {
                          value: _vm.configData.isFortnightly,
                          callback: function ($$v) {
                            _vm.$set(_vm.configData, "isFortnightly", $$v)
                          },
                          expression: "configData.isFortnightly",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formLabels.occurenceType.weekly) +
                            "\n                "
                        ),
                      ]
                    ),
                    _c(
                      "md-radio",
                      {
                        attrs: { value: true },
                        model: {
                          value: _vm.configData.isFortnightly,
                          callback: function ($$v) {
                            _vm.$set(_vm.configData, "isFortnightly", $$v)
                          },
                          expression: "configData.isFortnightly",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.formLabels.occurenceType.fortnightly) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm.configData.isFortnightly
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-size-20 md-medium-size-30 md-small-size-50 md-xsmall-size-100",
                      },
                      [
                        _c(
                          "md-datepicker",
                          {
                            attrs: {
                              "md-disabled-dates": _vm.disableNonMondays,
                              "md-immediately": "",
                              "md-debounce": 10,
                            },
                            model: {
                              value: _vm.configData.fortnightlyStartDate,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.configData,
                                  "fortnightlyStartDate",
                                  $$v
                                )
                              },
                              expression: "configData.fortnightlyStartDate",
                            },
                          },
                          [
                            _c("label", [
                              _vm._v(
                                _vm._s(_vm.formLabels.fortnightlyStartDate)
                              ),
                            ]),
                          ]
                        ),
                        _vm.isFormSubmitted &&
                        _vm.configData.fortnightlyStartDate == null
                          ? _c("span", { staticClass: "error error-message" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.formLabels.fortnightlyStartDate) +
                                  " is required.\n                "
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.weeklyData != null && _vm.weeklyData.length > 0
                  ? _c(
                      "div",
                      { staticClass: "md-layout-item md-size-100" },
                      [
                        _c(
                          "md-table",
                          { staticClass: "custom-paginated-table" },
                          [
                            _c(
                              "md-table-row",
                              { attrs: { slot: "header" }, slot: "header" },
                              [
                                _c("md-table-head", {
                                  staticClass: "label-column",
                                }),
                                _vm._l(_vm.dayColumns, function (col) {
                                  return _c(
                                    "md-table-head",
                                    { key: col, staticClass: "day-header" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(col) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            ),
                            _vm._l(_vm.availableWeeks, function (week) {
                              return _c(
                                "md-table-row",
                                { key: week.label },
                                [
                                  _vm.configData.isFortnightly
                                    ? _c(
                                        "md-table-cell",
                                        { staticClass: "label-column" },
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(week.label) +
                                              "\n                        "
                                          ),
                                        ]
                                      )
                                    : _c("md-table-cell", {
                                        staticClass: "label-column",
                                      }),
                                  _vm._l(week.days, function (day) {
                                    return _c(
                                      "md-table-cell",
                                      { key: day.key },
                                      [
                                        _c("md-checkbox", {
                                          staticClass: "day-checkbox",
                                          model: {
                                            value: day.checked,
                                            callback: function ($$v) {
                                              _vm.$set(day, "checked", $$v)
                                            },
                                            expression: "day.checked",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              )
                            }),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          ),
          _c(
            "div",
            { staticClass: "form-actions action-section" },
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary pull-right",
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("\n            Save Roster\n        ")]
              ),
            ],
            1
          ),
          _c(
            "form-wrapper",
            {
              staticClass: "unavailable-days-section md-layout",
              attrs: { validator: _vm.$v.blockoutDays },
            },
            [
              _c(
                "div",
                { staticClass: "md-layout-item md-small-size-100 md-size-70" },
                [
                  _c(
                    "div",
                    { staticClass: "header-section" },
                    [
                      _c("h5", { staticClass: "section-title" }, [
                        _vm._v("Unavailable Days"),
                      ]),
                      _c(
                        "md-button",
                        {
                          staticClass: "md-button md-primary",
                          class:
                            _vm.onGoingUpdateOfBlockoutDay ||
                            _vm.disableActionButtons
                              ? "md-disabled"
                              : "",
                          attrs: {
                            disabled:
                              _vm.onGoingUpdateOfBlockoutDay ||
                              _vm.disableActionButtons,
                          },
                          on: { click: _vm.addNewBlockoutDay },
                        },
                        [
                          _c("md-icon", [_vm._v("add")]),
                          _vm._v(
                            "\n                    Add Unavailable Day\n                "
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.hasBlockoutDays
                    ? _c(
                        "md-table",
                        {
                          staticClass:
                            "custom-paginated-table blockout-day-table",
                        },
                        [
                          _c(
                            "md-table-row",
                            { attrs: { slot: "header" }, slot: "header" },
                            [
                              _c("md-table-head", [_vm._v("Reason")]),
                              _c(
                                "md-table-head",
                                { staticClass: "start-date" },
                                [_vm._v("Start Date")]
                              ),
                              _c("md-table-head", { staticClass: "end-date" }, [
                                _vm._v("End Date"),
                              ]),
                              _c("md-table-head", [_vm._v("Attachments")]),
                              _c(
                                "md-table-head",
                                { staticClass: "action-column" },
                                [_vm._v("Actions")]
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.blockoutDays,
                            function (blockoutDay, index) {
                              return _c(
                                "md-table-row",
                                {
                                  key: index,
                                  staticClass: "row-data",
                                  class: {
                                    "selected-row":
                                      blockoutDay.inEditMode ||
                                      blockoutDay.inAddMode,
                                  },
                                },
                                [
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "reason-column" },
                                    [
                                      blockoutDay.inEditMode ||
                                      blockoutDay.inAddMode
                                        ? _c(
                                            "form-group",
                                            { attrs: { name: "reason" } },
                                            [
                                              _c("md-input", {
                                                attrs: { maxlength: "50" },
                                                model: {
                                                  value: blockoutDay.reason,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      blockoutDay,
                                                      "reason",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "blockoutDay.reason",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _c("p", [
                                            _vm._v(_vm._s(blockoutDay.reason)),
                                          ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "start-date" },
                                    [
                                      blockoutDay.inEditMode ||
                                      blockoutDay.inAddMode
                                        ? _c("md-datepicker", {
                                            attrs: {
                                              "md-immediately": "",
                                              "md-debounce": 100,
                                              "data-testid":
                                                "blockout-startDate",
                                              "md-model-type": String,
                                            },
                                            model: {
                                              value: blockoutDay.startDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  blockoutDay,
                                                  "startDate",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "blockoutDay.startDate",
                                            },
                                          })
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.transformDate(
                                                  blockoutDay.startDate
                                                )
                                              )
                                            ),
                                          ]),
                                      blockoutDay.isTouched &&
                                      blockoutDay.startDate == null
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "error error-message",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.formLabels.blockoutDays
                                                      .startDate
                                                  ) +
                                                  " is required.\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      blockoutDay.isTouched &&
                                      blockoutDay.startDate != null &&
                                      blockoutDay.endDate != null &&
                                      !_vm.$_isValidDateRange(
                                        blockoutDay.startDate,
                                        blockoutDay.endDate
                                      )
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "error error-message",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            Invalid date range.\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "start-date" },
                                    [
                                      blockoutDay.inEditMode ||
                                      blockoutDay.inAddMode
                                        ? _c("md-datepicker", {
                                            attrs: {
                                              "md-immediately": "",
                                              "md-debounce": 100,
                                              "data-testid": "blockout-endDate",
                                              "md-model-type": String,
                                            },
                                            model: {
                                              value: blockoutDay.endDate,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  blockoutDay,
                                                  "endDate",
                                                  $$v
                                                )
                                              },
                                              expression: "blockoutDay.endDate",
                                            },
                                          })
                                        : _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.transformDate(
                                                  blockoutDay.endDate
                                                )
                                              )
                                            ),
                                          ]),
                                      blockoutDay.isTouched &&
                                      blockoutDay.endDate == null
                                        ? _c(
                                            "span",
                                            {
                                              staticClass:
                                                "error error-message",
                                            },
                                            [
                                              _vm._v(
                                                "\n                            " +
                                                  _vm._s(
                                                    _vm.formLabels.blockoutDays
                                                      .endDate
                                                  ) +
                                                  " is required.\n                        "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "attachment-column" },
                                    [
                                      _vm.hasDocumentAttachment(blockoutDay) ||
                                      _vm.hasPhotoAttachment(blockoutDay)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "attachment-container",
                                            },
                                            [
                                              _c("blockout-days-document", {
                                                attrs: {
                                                  "blockout-day": blockoutDay,
                                                  "has-document-attachment":
                                                    _vm.hasDocumentAttachment,
                                                },
                                              }),
                                              _c("blockout-days-image", {
                                                attrs: {
                                                  "blockout-day": blockoutDay,
                                                  "has-photo-attachment":
                                                    _vm.hasPhotoAttachment,
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      blockoutDay.inAddMode ||
                                      blockoutDay.inEditMode
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "attachment-container",
                                            },
                                            [
                                              _c(
                                                "blockout-days-attachment-group",
                                                {
                                                  attrs: {
                                                    "attachment-list":
                                                      _vm.documentList,
                                                  },
                                                }
                                              ),
                                              _c(
                                                "blockout-days-attachment-group",
                                                {
                                                  attrs: {
                                                    "attachment-list":
                                                      _vm.imageList,
                                                    "file-type": "image",
                                                  },
                                                }
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "md-table-cell",
                                    { staticClass: "action-column" },
                                    [
                                      _c("blockout-days-button-group", {
                                        attrs: {
                                          "blockout-day": blockoutDay,
                                          index: index,
                                          "team-member-roster-configuration-id":
                                            _vm.configData
                                              .teamMemberRosterConfigurationId,
                                          "disable-action-buttons":
                                            _vm.disableActionButtons,
                                          "image-list": _vm.imageList,
                                          "document-list": _vm.documentList,
                                          "is-not-valid-date":
                                            _vm.isNotValidDate,
                                        },
                                        on: {
                                          update: _vm.editBlockoutDay,
                                          "undo-changes":
                                            _vm.undoChangesOnBlockoutDay,
                                          remove: _vm.removeBlockoutDay,
                                          saveChanges: _vm.handleSaveChanges,
                                          delete: _vm.handleDeleteBlockoutDay,
                                          imageListUpdate:
                                            _vm.handleImageListUpdate,
                                          documentListUpdate:
                                            _vm.handleDocumentListUpdate,
                                          blockoutDayUpdated:
                                            _vm.handleConfigurationUpdated,
                                          showErrorMessage:
                                            _vm.showErrorMessage,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  !_vm.hasBlockoutDays
                    ? _c("div", { staticClass: "text-center" }, [
                        _c("p", { staticClass: "no-result-message" }, [
                          _vm._v("No unavailable days."),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }